import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'que-smart-tooltip',
    imports: [CommonModule, TranslateDirective, TranslatePipe],
    templateUrl: './smart-tooltip.component.html',
    styleUrls: ['./smart-tooltip.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SmartTooltipComponent {

}
